<template>
  <button
    type="button"
    class="grid h-11 w-11 place-items-center rounded-full bg-primary-light text-ternary-dark shadow-sm transition-transform duration-300 hover:-rotate-12 hover:scale-110 hover:text-jelly-500 dark:bg-ternary-dark dark:text-ternary-light"
    :aria-label="`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`"
    @click="toggleTheme"
  >
    <Transition name="theme-swap" mode="out-in">
      <CustomIcon :key="theme" :name="theme === 'light' ? 'moon' : 'sun'" class="h-5 w-5" />
    </Transition>
  </button>
</template>

<script setup>
import CustomIcon from '@/components/base/CustomIcon.vue';
import { useTheme } from '@/composables/useTheme';

const { theme, toggleTheme } = useTheme();
</script>

<style scoped lang="scss">
.theme-swap-enter-active,
.theme-swap-leave-active {
  transition:
    transform var(--dur-fast) ease,
    opacity var(--dur-fast) ease;
}

.theme-swap-enter-from {
  opacity: 0;
  transform: rotate(-90deg) scale(0.4);
}

.theme-swap-leave-to {
  opacity: 0;
  transform: rotate(90deg) scale(0.4);
}
</style>
